<ng-container *ngIf="loginDisplay">
    <!-- HEADER -->
    <app-header></app-header>

    <!-- MAIN -->
    <router-outlet></router-outlet>
</ng-container>